import {prop, map} from 'ramda';
import services from 'services';
import {describeThrow} from 'utils/errors';
import msgs from 'dicts/messages';
import {mapResponseData} from 'utils/app';
import * as normalize from 'utils/normalize';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getMetrics = () =>
	httpJson('get', '/metrics', {})
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(prop('data'));

export const getLogs = (query = {}) =>
	httpJson('get', '/logs', query)
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(mapResponseData(map(normalize.log)));

export const getFeedback = query =>
	httpJson('get', '/feedback', {include: 'user', ...query})
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(mapResponseData(map(normalize.feedback)));
